(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initMobileNav() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var panel = document.querySelector('[data-mobile-nav]');
    if (!toggle || !panel) return;
    toggle.addEventListener('click', function () {
      var open = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.textContent = open ? 'Close' : 'Menu';
      document.body.classList.toggle('nav-open', open);
    });
  }

  function setAccordionHeight(item, open) {
    var panel = item.querySelector('[data-accordion-panel]') || item.querySelector('.accordion-item__panel');
    if (!panel) return;
    if (reduceMotion) {
      panel.style.maxHeight = open ? 'none' : '0px';
      return;
    }
    if (open) {
      panel.style.maxHeight = panel.scrollHeight + 'px';
      var onEnd = function () {
        if (item.classList.contains('is-open')) {
          panel.style.maxHeight = 'none';
        }
        panel.removeEventListener('transitionend', onEnd);
      };
      panel.addEventListener('transitionend', onEnd);
    } else {
      if (panel.style.maxHeight === 'none') {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
      void panel.offsetHeight;
      panel.style.maxHeight = '0px';
    }
  }

  function initAccordions() {
    document.querySelectorAll('[data-accordion]').forEach(function (root) {
      var items = root.querySelectorAll('[data-accordion-item]');
      items.forEach(function (item) {
        var trigger = item.querySelector('[data-accordion-trigger]');
        var panel = item.querySelector('.accordion-item__panel');
        if (!trigger || !panel) return;

        if (item.classList.contains('is-open')) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        } else {
          panel.style.maxHeight = '0px';
        }

        trigger.addEventListener('click', function () {
          var wasOpen = item.classList.contains('is-open');
          if (wasOpen) {
            item.classList.remove('is-open');
            var icon = item.querySelector('[data-accordion-icon]');
            if (icon) icon.textContent = '+';
            trigger.setAttribute('aria-expanded', 'false');
            setAccordionHeight(item, false);
          } else {
            // One open at a time: opening a question closes the others.
            // Alisa, 21 September 2026.
            items.forEach(function (other) {
              if (other === item || !other.classList.contains('is-open')) return;
              other.classList.remove('is-open');
              var oIcon = other.querySelector('[data-accordion-icon]');
              if (oIcon) oIcon.textContent = '+';
              var oTrig = other.querySelector('[data-accordion-trigger]');
              if (oTrig) oTrig.setAttribute('aria-expanded', 'false');
              setAccordionHeight(other, false);
            });
            item.classList.add('is-open');
            var icon = item.querySelector('[data-accordion-icon]');
            if (icon) icon.textContent = '−';
            trigger.setAttribute('aria-expanded', 'true');
            setAccordionHeight(item, true);
          }
        });
      });

      window.addEventListener('resize', function () {
        items.forEach(function (item) {
          if (item.classList.contains('is-open')) {
            var panel = item.querySelector('.accordion-item__panel');
            if (panel && panel.style.maxHeight !== 'none') {
              panel.style.maxHeight = panel.scrollHeight + 'px';
            }
          }
        });
      });
    });
  }

  function initHero() {
    var sliders = document.querySelectorAll('[data-hero-slider]');
    sliders.forEach(function (slider) {
      var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-hero-slide]'));
      if (!slides.length) return;

      var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-hero-dot]'));
      var prev = slider.querySelector('[data-hero-prev]');
      var next = slider.querySelector('[data-hero-next]');
      var caption = document.querySelector('[data-hero-caption]');
      var bars = Array.prototype.slice.call(document.querySelectorAll('[data-hero-bar]'));
      var scrollCue = document.querySelector('[data-hero-scroll]');
      var hold = parseInt(slider.getAttribute('data-hold'), 10) || 6000;
      var current = 0;
      var timer;
      var touching = false;
      var startX = 0;

      function show(i) {
        if (i < 0) i = slides.length - 1;
        if (i >= slides.length) i = 0;
        slides.forEach(function (s, idx) {
          var on = idx === i;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
        dots.forEach(function (d, idx) {
          var on = idx === i;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        bars.forEach(function (b, idx) {
          var on = idx === i;
          b.classList.toggle('hero-meta__bar--muted', !on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        if (caption) {
          caption.style.opacity = '0';
          window.setTimeout(function () {
            caption.textContent = slides[i].getAttribute('data-caption') || 'Untitled *';
            caption.style.opacity = '1';
          }, reduceMotion ? 0 : 160);
        }
        current = i;
      }

      function go(delta) {
        show(current + delta);
        reset();
      }

      function reset() {
        clearInterval(timer);
        if (!reduceMotion && !touching && slides.length > 1) {
          timer = setInterval(function () {
            show(current + 1);
          }, hold);
        }
      }

      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          show(parseInt(d.getAttribute('data-hero-dot'), 10));
          reset();
        });
      });

      bars.forEach(function (b, idx) {
        b.addEventListener('click', function () {
          show(idx);
          reset();
        });
      });

      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });

      slider.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') go(-1);
        if (e.key === 'ArrowRight') go(1);
      });
      slider.setAttribute('tabindex', '0');

      slider.addEventListener('mouseenter', function () { clearInterval(timer); });
      slider.addEventListener('mouseleave', function () { reset(); });

      slider.addEventListener('touchstart', function (e) {
        touching = true;
        clearInterval(timer);
        startX = e.changedTouches[0].screenX;
      }, { passive: true });

      slider.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].screenX - startX;
        touching = false;
        if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
        else reset();
      }, { passive: true });

      if (scrollCue) {
        var hideScroll = function () {
          if (window.scrollY > 24) {
            scrollCue.classList.add('is-gone');
            window.removeEventListener('scroll', hideScroll);
          }
        };
        window.addEventListener('scroll', hideScroll, { passive: true });
      }

      show(0);
      reset();
    });
  }

  function initFormatGroups() {
    document.querySelectorAll('[data-format-group]').forEach(function (group) {
      var head = group.querySelector('[data-format-toggle]');
      if (!head) return;
      head.addEventListener('click', function () {
        var parent = group.parentElement;
        if (parent) {
          parent.querySelectorAll('[data-format-group]').forEach(function (g) {
            g.classList.add('format-group--closed');
          });
        }
        group.classList.remove('format-group--closed');
      });
    });
  }

  function initProductForm() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');
    var priceEl = form.querySelector('[data-product-price]');
    var options = form.querySelectorAll('[data-variant-option]');

    options.forEach(function (btn) {
      btn.addEventListener('click', function () {
        options.forEach(function (o) { o.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        var id = btn.getAttribute('data-variant-id');
        var price = btn.getAttribute('data-variant-price');
        if (idInput && id) idInput.value = id;
        if (priceEl && price) priceEl.textContent = price;
      });
    });
  }

  function initToneSelect() {
    var wraps = document.querySelectorAll('[data-tone-select], [data-tone-dropdown]');
    wraps.forEach(function (wrap) {
      var btn = wrap.querySelector('[data-tone-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = wrap.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    document.addEventListener('click', function () {
      wraps.forEach(function (wrap) {
        wrap.classList.remove('is-open');
        var btn = wrap.querySelector('[data-tone-toggle]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function initGalleryFilters() {
    var root = document.querySelector('[data-gallery-js]');
    if (!root) return;

    var metaEl = root.querySelector('[data-gallery-meta]');
    var meta = { intros: {}, next: {} };
    try {
      meta = JSON.parse(metaEl ? metaEl.textContent : '{}');
    } catch (e) {}

    var baseUrl = root.getAttribute('data-base-url') || window.location.pathname;
    var frames = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-frame]'));
    var emptyEl = root.querySelector('[data-gallery-empty]');
    var hangEl = root.querySelector('[data-gallery-hang]');
    var gridEl = root.querySelector('[data-gallery-grid]');
    var introEl = root.querySelector('.gallery-intro p');
    var nextTitle = root.querySelector('[data-gallery-next-title]');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.gallery-filters__tab'));
    var toneLinks = Array.prototype.slice.call(root.querySelectorAll('.tone-select__menu a'));
    var toneBtnLabel = root.querySelector('.tone-select__btn span');

    function params() {
      var q = new URLSearchParams(window.location.search);
      return {
        subject: q.get('subject') || 'all',
        tone: q.get('tone') || 'all'
      };
    }

    function buildUrl(subject, tone) {
      var q = new URLSearchParams();
      if (subject && subject !== 'all') q.set('subject', subject);
      if (tone && tone !== 'all') q.set('tone', tone);
      var s = q.toString();
      return s ? baseUrl + '?' + s : baseUrl;
    }

    function toneLabel(tone) {
      if (tone === 'black-white') return 'Black & White';
      if (tone === 'sepia') return 'Sepia';
      if (tone === 'color') return 'Color';
      return 'All tones';
    }

    function apply() {
      var p = params();
      var visible = 0;

      frames.forEach(function (frame) {
        var s = frame.getAttribute('data-subject') || 'all';
        var t = frame.getAttribute('data-tone') || 'all';
        var ok = true;
        if (p.subject !== 'all' && s !== p.subject) ok = false;
        if (p.tone !== 'all' && t !== p.tone && t !== 'all') ok = false;
        frame.hidden = !ok;
        frame.style.display = ok ? '' : 'none';
        if (ok) visible += 1;
      });

      root.querySelectorAll('[data-gallery-breath]').forEach(function (b) {
        var next = b.nextElementSibling;
        var show = next && next.hasAttribute('data-gallery-frame') && next.style.display !== 'none' && !next.hidden;
        b.hidden = !show;
        b.style.display = show ? '' : 'none';
      });

      if (emptyEl) {
        emptyEl.hidden = visible > 0;
        emptyEl.style.display = visible > 0 ? 'none' : '';
        var chips = emptyEl.querySelector('[data-gallery-chips]');
        if (chips) {
          chips.innerHTML = '';
          if (p.subject !== 'all') {
            var a = document.createElement('a');
            a.className = 'chip';
            a.href = buildUrl('all', p.tone);
            a.textContent = p.subject + ' ×';
            chips.appendChild(a);
          }
          if (p.tone !== 'all') {
            var b = document.createElement('a');
            b.className = 'chip';
            b.href = buildUrl(p.subject, 'all');
            b.textContent = p.tone + ' ×';
            chips.appendChild(b);
          }
          var clear = document.createElement('a');
          clear.className = 'chip chip--clear';
          clear.href = baseUrl;
          clear.textContent = 'Clear all';
          chips.appendChild(clear);
        }
      }

      if (hangEl) hangEl.style.display = visible > 0 ? '' : 'none';
      if (gridEl) gridEl.style.display = visible > 0 ? '' : 'none';

      if (introEl && meta.intros) {
        introEl.textContent = meta.intros[p.subject] || meta.intros.all || introEl.textContent;
      }

      if (nextTitle && meta.next) {
        var n = meta.next[p.subject] || meta.next.all;
        if (n) {
          nextTitle.textContent = n.label;
          nextTitle.setAttribute('href', buildUrl(n.handle, 'all'));
        }
      }

      tabs.forEach(function (tab) {
        var href = tab.getAttribute('href') || '';
        var usp = new URL(href, window.location.origin).searchParams;
        var sub = usp.get('subject') || 'all';
        tab.classList.toggle('is-active', sub === p.subject);
      });

      toneLinks.forEach(function (link) {
        var href = link.getAttribute('href') || '';
        var usp = new URL(href, window.location.origin).searchParams;
        var tone = usp.get('tone') || 'all';
        link.classList.toggle('is-active', tone === p.tone);
      });

      if (toneBtnLabel) toneBtnLabel.textContent = toneLabel(p.tone);

      root.setAttribute('data-subject', p.subject);
      root.setAttribute('data-tone', p.tone);
    }

    function onFilterClick(e) {
      var a = e.target.closest('a');
      if (!a || !root.contains(a)) return;
      if (!a.classList.contains('gallery-filters__tab') && !a.closest('.tone-select__menu') && !a.classList.contains('chip')) return;
      var url = new URL(a.href, window.location.origin);
      if (url.pathname.replace(/\/$/, '') !== String(baseUrl).replace(/\/$/, '') && url.pathname.indexOf('/collections/') === -1) return;
      e.preventDefault();
      history.pushState({}, '', a.href);
      apply();
      var wrap = root.querySelector('[data-tone-select]');
      if (wrap) wrap.classList.remove('is-open');
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    root.addEventListener('click', onFilterClick);
    window.addEventListener('popstate', apply);
    apply();
  }

  function initJournal() {
    var root = document.querySelector('[data-journal-view]');
    if (!root) return;
    var index = root.querySelector('[data-journal-index]');
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-journal-entry]'));

    function show() {
      var q = new URLSearchParams(window.location.search).get('entry');
      var shown = false;
      panels.forEach(function (p) {
        var on = !!(q && p.getAttribute('data-journal-entry') === q);
        p.hidden = !on;
        if (on) shown = true;
      });
      if (index) index.hidden = shown;
      if (shown) window.scrollTo(0, 0);
    }

    root.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a || !a.href) return;
      var url = new URL(a.href, window.location.origin);
      if (url.pathname.indexOf('/blogs/') === -1) return;
      if (url.searchParams.get('entry')) {
        e.preventDefault();
        history.pushState({}, '', a.href);
        show();
        return;
      }
      if (index && index.hidden && !url.searchParams.get('entry')) {
        e.preventDefault();
        history.pushState({}, '', url.pathname);
        show();
      }
    });
    window.addEventListener('popstate', show);
    show();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initHero();
    initAccordions();
    initFormatGroups();
    initProductForm();
    initToneSelect();
    initGalleryFilters();
    initJournal();
  });

  document.addEventListener('shopify:section:load', function () {
    initHero();
    initAccordions();
    initGalleryFilters();
  });
})();


